import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useLocation } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import HorseImg from '../../../assets/icons/horse-configurator.webp';
import JockeyImg from '../../../assets/icons/jockey.webp';
import { useJockeys, useSkins } from '../../../hooks/stable';
import { useAppDispatch, useAppSelector } from '../../../store/reducers';
import { getHorseConfigurations, getVisitedUsersConfigurations } from '../../../store/reducers/Stable/configurator';
import styles from './Configurator.module.scss';
import SingleConfiguratorView from './SingleConfiguratorView/SingleConfiguratorView';
const Configurator = ({ horse, isJockey }) => {
    const { configurator } = useAppSelector((state) => state.configurator);
    const { jockeyIndex } = useAppSelector((state) => state.configurator);
    const { visitedStableUserId } = useAppSelector((state) => state.app);
    const { t } = useTranslation();
    const [jockeyImage, setJockeyImage] = useState(null);
    const [horseImage, setHorseImage] = useState(null);
    const [jockeySkin, setJockeySkin] = useState('');
    const [horseSkin, setHorseSkin] = useState('');
    const { skins } = useSkins();
    const { jockeys } = useJockeys();
    const dispatch = useAppDispatch();
    const param = useParams();
    const pathname = useLocation();
    const setImage = useCallback((assetName, configuratorName, image, displayName) => {
        const parseImg = assetName !== '' ? image.src.replace('ipfs://', 'https://ipfs.io/ipfs/') : null;
        displayName = assetName !== '' ? displayName : '';
        switch (configuratorName) {
            case 'jockey-skins':
                setJockeyImage(parseImg);
                setJockeySkin(displayName);
                break;
            case 'horse-skins':
                setHorseImage(parseImg);
                setHorseSkin(displayName);
                break;
        }
    }, [configurator]);
    useEffect(() => {
        if (!(horse === null || horse === void 0 ? void 0 : horse.static.asset.assetName))
            return;
        const { assetName } = horse.static.asset;
        if (visitedStableUserId && visitedStableUserId != '') {
            dispatch(getVisitedUsersConfigurations({ userId: visitedStableUserId, horseId: assetName }));
        }
        else {
            dispatch(getHorseConfigurations(assetName));
        }
    }, [dispatch, horse === null || horse === void 0 ? void 0 : horse.static.asset.assetName, horse]);
    const setSkinImage = (type) => {
        if (configurator) {
            if (!configurator[type]) {
                const _jockey = jockeys === null || jockeys === void 0 ? void 0 : jockeys.find((el) => el.asset.assetName === configurator['jockey']);
                if (type === 'jockey-skins' && jockeys && _jockey) {
                    setImage(_jockey.asset.assetName, type, _jockey.image, _jockey.displayName);
                }
                else {
                    setImage('', type, JockeyImg, t('default_applied'));
                }
            }
        }
        if (!(configurator && skins))
            return;
        if (!configurator[type])
            return;
        const skinName = configurator[type];
        const skin = skins === null || skins === void 0 ? void 0 : skins.find((skin) => skin.asset.assetName === skinName);
        if (skin !== undefined) {
            setImage(skinName, type, skin.image, skin.displayName);
        }
    };
    useEffect(() => {
        setSkinImage('jockey-skins');
        setSkinImage('horse-skins');
    }, [configurator, skins, setImage, pathname]);
    useEffect(() => {
        setJockeyImage(null);
        setHorseImage(null);
        setJockeySkin('');
        setHorseSkin('');
    }, []);
    const isJockeySkin = (skin) => ['Jockey Skin', 'Deluxe Skin'].includes(skin.type);
    const isHorseSkin = (skin) => ['Horse Skin', 'Deluxe Skin'].includes(skin.type);
    return (_jsx("div", Object.assign({ className: cn(styles.element, 'd-flex') }, { children: !isJockey ? (_jsxs(_Fragment, { children: [_jsx(SingleConfiguratorView, { id: param.id || '', name: t('Jockey Skin'), activateTab: "Jockey", amount: (skins === null || skins === void 0 ? void 0 : skins.filter(isJockeySkin).length) || 0, desc: jockeySkin ? jockeySkin : t('default_applied'), image: jockeyImage || JockeyImg }), _jsx(SingleConfiguratorView, { id: param.id || '', name: t('Horse Skin'), activateTab: "Horse", amount: (skins === null || skins === void 0 ? void 0 : skins.filter(isHorseSkin).length) || 0, desc: horseSkin ? horseSkin : t('default_applied'), image: horseImage || HorseImg })] })) : (_jsx(SingleConfiguratorView, { id: param.id || '', activateTab: "Jockey", name: horseSkin ? horseSkin : t('jockey'), amount: (jockeys === null || jockeys === void 0 ? void 0 : jockeys.length) || 0, desc: t('default_applied'), image: jockeyImage || JockeyImg })) })));
};
export default Configurator;
